import { defineComponent as d, toRef as r, ref as f, computed as c, watch as v, h as t, TransitionGroup as h } from "vue";
import s from "./ghl-ui.es1541.js";
import x from "./ghl-ui.es1542.js";
import p from "./ghl-ui.es868.js";
import y from "./ghl-ui.es830.js";
const M = d({
  name: "BaseSlotMachine",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    value: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: Number,
      default: void 0
    },
    appeared: {
      type: Boolean,
      required: !0
    }
  },
  setup(n) {
    p("-base-slot-machine", x, r(n, "clsPrefix"));
    const u = f(), l = f(), i = c(() => {
      if (typeof n.value == "string")
        return [];
      if (n.value < 1)
        return [0];
      const a = [];
      let e = n.value;
      for (n.max !== void 0 && (e = Math.min(n.max, e)); e >= 1; )
        a.push(e % 10), e /= 10, e = Math.floor(e);
      return a.reverse(), a;
    });
    return v(r(n, "value"), (a, e) => {
      typeof a == "string" ? (l.value = void 0, u.value = void 0) : typeof e == "string" ? (l.value = a, u.value = void 0) : (l.value = a, u.value = e);
    }), () => {
      const {
        value: a,
        clsPrefix: e
      } = n;
      return typeof a == "number" ? t("span", {
        class: `${e}-base-slot-machine`
      }, t(h, {
        name: "fade-up-width-expand-transition",
        tag: "span"
      }, {
        default: () => i.value.map((m, o) => t(s, {
          clsPrefix: e,
          key: i.value.length - o - 1,
          oldOriginalNumber: u.value,
          newOriginalNumber: l.value,
          value: m
        }))
      }), t(y, {
        key: "+",
        width: !0
      }, {
        default: () => n.max !== void 0 && n.max < a ? t(s, {
          clsPrefix: e,
          value: "+"
        }) : null
      })) : t("span", {
        class: `${e}-base-slot-machine`
      }, a);
    };
  }
});
export {
  M as default
};
